/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Cloud_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Cloud URL" |
*
* @param {Media_Import_Cloud_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_cloud_placeholder = /** @type {((inputs?: Media_Import_Cloud_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Cloud_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL du cloud")
	if (locale === "de") return /** @type {LocalizedString} */ ("Cloud-URL")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL del cloud")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL облака")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL de la nube")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("云网址")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クラウドURL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लाउड यूआरएल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL da nuvem")
	return /** @type {LocalizedString} */ ("Cloud URL")
});